<template>
    <div class="wrapper">
        <div class="use">
            <div class="content">
                <span class="logo">
                    <img src="../assets/logo.png" alt="logo">
                </span>
                <div class="head">
                    <header></header>
                    <span class="title">{{ticket.ticketName}}</span>
                </div>
                <div class="body">
                    <div class="code">
                        <div class="tip">券码有效期至{{ticket.expiredDate}},请您尽快完成券码使用,券码超过有效期未使用,服务商无法为您提供换券服务。</div>
                    </div>
                    <div class="sec" v-if="kami === 1">兑换码：{{ticket.outTicketPsw}}</div>
					<div class="sec" v-if="kami === 2">
						<div style="width: 13%;float: left;">&nbsp;<br />&nbsp;</div>
						<div style="text-align: left;">
							<span>卡号：</span>{{ticket.outTicketNumber}}<br />
							<span>卡密：</span>{{ticket.outTicketPsw}}
						</div>
					</div>
					<div class="dec">网点存在变动可能，使用前请先确认服务网点信息</div>
					<div class="btn"><router-link to='/drjingStore' class="button">查看服务网点</router-link></div>
                </div>
                <div class="foot">
                    <h1>券码规则</h1>
                    <div v-html="ticket.regulation" class="tip"></div>
					<div v-for="item in ticket.supplierProductCaptionList" :key="item.id" class="caption">
						<p v-if="item.showPictureCaptions === 1">{{ item.pictureCaptions }}</p>
						<img v-if="item.imgPath && item.imgPath.length > 0" :src="item.imgPath" alt="">
					</div>
                </div>
            </div>
        </div>
        <div class="use_loading" v-if="loading">
            <div class="loading">
                <img src="../assets/loading.png" alt="加载中">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            loading:true,
            key:this.$route.query.key,
            mobile: this.$route.query.mobile,
            name:'',
            effectiveDate:'',
            expiredDate:'',
            ticket:{},
			kami: 1
        }
    },
    mounted(){
        this.getTicket();
    },
    methods:{
        getTicket(){
            const obj = {
                ticketNo:this.key,
                isVerify:'-1',
                mobile:this.mobile
            };
            this.$http.POST('productTicket/selectProductTicket',obj).then(res=>{
                this.loading = false;
                if(res.code===0){
                    if(res.data.status==2||res.data.status==3){
                        this.used = true;
                    }else{
                        this.used = false;
                        this.ticket = res.data;
                        this.name = this.ticket.ticketName;
                        document.title = this.name;
						if(this.ticket.productCategoryList[0].showType === 5){
							this.kami = 2;
						}
                    }
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    height: 100%;
    position: relative;
    .use{
        // height: 100%;
        background: #108EE9;
        padding: 30px 15px 15px 15px;
        box-sizing: border-box;
        .content{
            background: #fff;
            border-radius: 4px;
            background: url('../assets/code_bg.png') #fff center 20px no-repeat;
            background-size: 305px 338px;
            min-height: 338px;
            position: relative;
            .logo{
                position: absolute;
                display: inline-block;
                right: 0;
                top: 0;
                img{
                    width: 51px;
                    height: 51px;
                }
            }
            .head{
                position: relative;
                height: 30px;
                width: 100%;
                display: flex;
                justify-content: center;
                header{
                    width: 250px;
                    border-top: 30px solid #2C78DC;
                    border-right: 12px solid transparent;
                    border-left:12px solid transparent;
                    box-sizing: border-box;
                    height: 30px;
                }
                .title{
                    font-size: 15px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    color: #fff;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                }
            }
            .body{
                border-bottom:1px dashed #CCCCCC;
                p{
                    font-size: 15px;
                    color: #999999;
                    text-align: center;
                    padding-top: 10px;
                }
                h1{
                    font-size: 20px;
                    color: #333333;
                    text-align: center;
                    padding-top: 15px;
                }
                .code{
                    padding-top: 40px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .qrcode{
                        padding-top: 20px;
                    }
                    .tip{
                        width:75%;
                        background:yellow;
                        font-size:12px;
                    }
                }
                .sec{
                    font-size: 15px;
                    color: #F76A24;
                    padding: 30px 0 15px 0;
                    text-align: center;
                    font-weight:bold;
                    font-size:16px;
                }
                .dec{
                    font-size: 15px;
                    background: #FEFCEC;
                    padding: 10px 0;
                    color: #F76A24;
                    text-align: center;
                }
                .btn{
                    display: flex;
                    justify-content: center;
                    padding: 15px 0 30px 0;
                    .button{
                        font-size: 15px;
                        width: 200px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        background: #1E87FC;
                        border-radius: 4px;
                    }
                }
            }
            .foot{
                padding: 24px 17px;
                h1{
                    font-size: 20px;
                    color: #333333;
                    font-weight: bold;
                }
                .tip{
                    color: #666666;
                    font-size: 15px;
                    line-height: 28px;
                }
				.caption{
					img{
						max-width:100%;
						padding:5px 0;
					}
					p{
						color: #666666;
						font-size: 15px;
						line-height: 28px;
					}
				}
            }
        }
    }
    
    .use_loading{
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 11;
        left: 0;
        top: 0;
        .loading{
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width:50px;
                height: 50px;
                animation:turn .8s linear infinite;      
                margin: 100px auto;
            }
            @keyframes turn{
                0%{-webkit-transform:rotate(0deg);}
                25%{-webkit-transform:rotate(90deg);}
                50%{-webkit-transform:rotate(180deg);}
                75%{-webkit-transform:rotate(270deg);}
                100%{-webkit-transform:rotate(360deg);}
            }
        }
    } 
}
</style>